import axiosInstance from "@/api/axios-instance";

export async function declineUserRequest(id: string, reason: string) {
  const response = await axiosInstance.patch(
    `/user-requests/${id}/decline`,
    { reason },
  );
  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to decline user request");
  }
  return response.data;
}
